import { Component, OnInit } from '@angular/core'
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms"
import { ActivatedRoute } from "@angular/router"
import { NotificationService } from "../../../../../../notification/shared/notification.service"
import { BasketService } from "../../../../../basket/shared/basket.service"
import { Porteur } from "../../../shared/porteur"

@Component({
  selector: 'app-nom',
  templateUrl: './nom.component.html',
  styleUrls: ['./nom.component.scss']
})
export class NomComponent implements OnInit {
  porteur: Porteur;
  identityForm: FormGroup = new FormGroup({
    'lastname': new FormControl('', [
      Validators.required,
      Validators.pattern('^(?=.*[a-zA-Z0-9 \u0080-\u00ff^-]+)[a-zA-Z0-9 \u0080-\u00ff^-]+$')
    ]),
    'firstname': new FormControl('', [
      Validators.required,
      Validators.pattern('^(?=.*[a-zA-Z0-9 \u0080-\u00ff^-\s]+)[a-zA-Z0-9 \u0080-\u00ff^-]+$')
    ])
  })
  constructor(private route: ActivatedRoute,
    private basketService: BasketService,
    private notificationService: NotificationService) { }

  ngOnInit() {
    this.route.parent.data.subscribe(data => {
      this.porteur = data.porteur
    })
  }

  get lastname(): AbstractControl {
    return this.identityForm.get('lastname');
  }
  get firstname(): AbstractControl {
    return this.identityForm.get('firstname');
  }

  submitForm() {
    if (null !== this.porteur && this.identityForm.valid) {
      this.basketService.addBasketLine({
        type: "CHANGEMENT DE NOM",
        numPorteur: this.porteur.numPorteur,
        firstname: this.identityForm.get('firstname').value,
        lastname: this.identityForm.get('lastname').value,
        codeService: this.porteur.codeService,
      }).subscribe(res => this.success())
    }
  }

  success() {
    this.notificationService.notif("Votre demande de modification de nom et de fonction a été ajoutée au panier. Elle sera automatiquement supprimée sous 2 jours si elle n'est pas validée.", "notif");
  }

}
